<template>
	<FormGroup
		:id="$attrs.id"
		:label="label"
		:required="required"
		:help-text="helpText"
		v-slot="{ id }"
	>
		<select
			:id="`form-input-${id}`"
			class="custom-select"
			:class="inputClass"
			:value="value"
			@input="$emit('input', $event.target.value)"
			@focus="$emit('focus', $event)"
			@blur="$emit('blur', $event.target.value)"
			:disabled="disabled"
			:required="required"
		>
			<option v-if="placeholder" :value="null" disabled="disabled">
				{{ placeholder }}
			</option>
			<option v-if="nullOption" :value="null">{{ nullOption }}</option>
			<option
				v-for="(option, index) in options"
				:key="optionKey(option, index)"
				:value="option[valueField]"
				:disabled="option[disabledField]"
			>
				{{ option[labelField] }}
			</option>
		</select>
	</FormGroup>
</template>
<script>
import FormGroup from '~/components/ui/form/FormGroup'

export default {
	components: {
		FormGroup
	},
	props: {
		label: {
			type: String,
			default: null
		},
		value: {
			default: null
		},
		options: {
			type: Array,
			default: () => []
		},
		nullOption: {
			type: String,
			default: null
		},
		labelField: {
			type: String,
			default: 'label'
		},
		valueField: {
			type: String,
			default: 'value'
		},
		disabledField: {
			type: String,
			default: 'disabled'
		},
		placeholder: {
			type: String,
			default: null
		},
		helpText: {
			type: String,
			default: null
		},
		required: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		selectFirst: {
			type: Boolean,
			default: false
		},
		inputClass: {
			type: [String, Object, Array],
			default: null
		}
	},
	watch: {
		options: {
			handler() {
				if (
					!this.value &&
					this.selectFirst &&
					this.options.length > 0
				) {
					this.$emit('input', this.options[0][this.valueField])
				}
			},
			immediate: true
		}
	},
	methods: {
		optionKey(option, index) {
			const value = option[this.valueField]

			return `option-${value !== null && value !== undefined ? value : index}`
		}
	}
}
</script>
